import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import messages from '../employeeMessages';

const UpdateEmployeeProfileModal = ({ show, intl, onSave, onClose, profiles }) => {
  const [selectedProfileId, setSelectedProfileId] = useState('');
  const [touched, setTouched] = useState(false);

  const handleSave = () => {
    setTouched(true);
    if (!selectedProfileId) return;
    return onSave(selectedProfileId);
  };

  const handleClose = () => {
    setSelectedProfileId('');
    setTouched(false);
    onClose();
  };

  if (!show) return null;

  const formGroupClassName = classNames('form-group', {
    'has-error': touched && !selectedProfileId,
  });

  return (
    <OkCancelModal
      title={intl.formatMessage(messages.UpdateProfile)}
      show={show}
      onClose={handleClose}
      disabled={!selectedProfileId}
      onSave={handleSave}
    >
      <div className="form-horizontal">
        <div className={formGroupClassName}>
          <label className="control-label col-sm-4">
            {intl.formatMessage(messages.PriceProfile)}
          </label>
          <div className="col-sm-5">
            <select
              onChange={e => {
                setTouched(true);
                setSelectedProfileId(e.target.value);
              }}
              className="form-control"
              value={selectedProfileId}
            >
              <option value="" />
              {(profiles || []).map(profile => (
                <option key={profile.id} value={profile.id}>
                  {profile.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </OkCancelModal>
  );
};

UpdateEmployeeProfileModal.propTypes = {
  show: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  profiles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

UpdateEmployeeProfileModal.defaultProps = { profiles: [] };

export default UpdateEmployeeProfileModal;
